"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__resetLogoutCleanupForTests = __resetLogoutCleanupForTests;
exports.registerLogoutCleanup = registerLogoutCleanup;
exports.runLogoutCleanup = runLogoutCleanup;
var callbacks = new Set();

function registerLogoutCleanup(callback) {
  if (typeof callback !== 'function') return function () {};
  callbacks.add(callback);
  return function () {
    return callbacks["delete"](callback);
  };
}

function runLogoutCleanup() {
  callbacks.forEach(function (callback) {
    try {
      callback();
    } catch (error) {
      // Never let a misbehaving callback block the logout redirect.
      // eslint-disable-next-line no-console
      console.warn('logout cleanup callback failed', error);
    }
  });
}

function __resetLogoutCleanupForTests() {
  callbacks.clear();
}